function setCustomError(type, typeName, instance, message) {
	Object.defineProperty(instance, 'name', {
		enumerable: false,
		writable: false,
		value: typeName
	});

	Object.defineProperty(instance, 'message', {
		enumerable: false,
		writable: true,
		value: message
	});

	if (Error.hasOwnProperty('captureStackTrace')) {
		// V8
		Error.captureStackTrace(instance, type);
	} else {
		Object.defineProperty(instance, 'stack', {
			enumerable: false,
			writable: false,
			value: new Error(message).stack
		});
	}
}

function setErrorPrototype(type) {
	if (typeof Object.setPrototypeOf === 'function') {
		Object.setPrototypeOf(type.prototype, Error.prototype);
	} else {
		type.prototype = Object.create(Error.prototype, {
			constructor: { value: type }
		});
	}
}

export function AuthenticationError(message) {
	setCustomError(AuthenticationError, 'AuthenticationError', this, message);
}

export function AuthorizationError(message) {
	setCustomError(AuthorizationError, 'AuthorizationError', this, message);
}
setErrorPrototype(AuthorizationError);

export function SystemError(message) {
	setCustomError(SystemError, 'SystemError', this, message);
}
setErrorPrototype(SystemError);

export function ValidationError(message) {
	setCustomError(ValidationError, 'ValidationError', this, message);
}
setErrorPrototype(ValidationError);
